module.exports = __webpack_public_path__ + "img/enerdata.d19564e.png";